import { IonButton, IonContent, IonIcon, IonPage, useIonAlert } from '@ionic/react';
import { helpCircleOutline } from 'ionicons/icons';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

import ListItem from '../../components/list/ListItem';
import LoadingContainer from '../../components/loading/LoadingContainer';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { objIsEmpty } from '../../library/Funcs';
import { FundGetAction } from '../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './Fund.css';

const Fund: React.FC = () => {
    let fund_key = 0

    const history = useHistory();
    
    const [alert] = useIonAlert();

    const dispatch = useAppDispatch()
    const { loading, fund } = useAppSelector(state => state.fundGetReducer)

    useEffect(() => {
        if (objIsEmpty(fund)) {
            dispatch(FundGetAction())
        }
    }, [dispatch])

    const showInfoHandler = () => {
        alert({
            message: "این صندوق از محل پرداخت های ثابت ماهانه و متفرقه اعضا از طریق صفحه پرداخت شارژ و در مواقع ضروری هزینه می شود.",
            buttons: [
                {
                    text: "مشاهده صفحه پرداخت", handler: () => {
                        history.push("/pay");
                    }
                },
                { text: "متوجه شدم" }
            ]
        })
    }

    return <LoadingContainer loading={loading}>
        <IonPage>
            <Toolbar title="صندوق ذخیره" subTitle={fund.credit} hasBackButton>
                <IonButton shape="round" onClick={showInfoHandler}>
                    <IonIcon icon={helpCircleOutline} />
                </IonButton>
            </Toolbar>

            <LayoutGap />

            <IonContent className="main-content">
                {fund.funds?.map((item: any) => {
                    let color = "grey";

                    return <ListItem key={`fund-item-${++fund_key}`} title={item.title} value={item.price} valueText="مبلغ پرداختی" valueBadge date={item.date} dateTitle="تاریخ پرداخت" color={color} link={`/campaign/${item.campaign_id}`} />
                })}
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default Fund